/* ============================================================
   Cellebration custom header behaviour:
   - shrink nav on scroll
   - light/dark mode toggle (theme-a1 <-> theme-a2), persisted
   - desktop mega-menu: hover via CSS, tap/keyboard via JS
   - mobile drawer open/close (scroll lock, ESC, tap-outside)
   Safe to run multiple times (theme editor re-renders).
   ============================================================ */
(function () {
  var STORAGE_KEY = 'cb-theme';

  function currentTheme() {
    return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  }

  function applyTheme(t) {
    document.documentElement.setAttribute('data-theme', t);
    try {
      localStorage.setItem(STORAGE_KEY, t);
    } catch (e) {}
  }

  function initModeToggle(root) {
    var btn = root.querySelector('[data-mode-toggle]');
    if (!btn || btn.dataset.cbBound) return;
    btn.dataset.cbBound = '1';
    btn.addEventListener('click', function () {
      applyTheme(currentTheme() === 'light' ? 'dark' : 'light');
    });
  }

  function initScroll(root) {
    var nav = root.querySelector('.site-nav');
    if (!nav || nav.dataset.cbScroll) return;
    nav.dataset.cbScroll = '1';
    var onScroll = function () {
      nav.classList.toggle('scrolled', window.scrollY > 32);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initMobileDrawer(root) {
    var toggle = root.querySelector('.mobile-toggle');
    var drawer = root.querySelector('.mobile-drawer');
    if (!toggle || !drawer || toggle.dataset.cbBound) return;
    toggle.dataset.cbBound = '1';

    function open() {
      drawer.classList.add('open');
      toggle.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('open');
      toggle.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', function () {
      drawer.classList.contains('open') ? close() : open();
    });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) close();
    });
  }

  function initMega(root) {
    var triggers = root.querySelectorAll('.has-mega, .has-dropdown');
    if (!triggers.length) return;

    function closeAll(except) {
      triggers.forEach(function (t) {
        if (t !== except) t.classList.remove('is-open');
      });
    }

    triggers.forEach(function (item) {
      if (item.dataset.cbBound) return;
      item.dataset.cbBound = '1';
      var link = item.querySelector('.nav-link');
      if (!link) return;
      link.addEventListener('click', function (e) {
        var target = e.target;
        var isCaret = target && target.classList && target.classList.contains('caret');
        if (isCaret || link.tagName === 'BUTTON') {
          e.preventDefault();
          var wasOpen = item.classList.contains('is-open');
          closeAll(item);
          if (!wasOpen) item.classList.add('is-open');
        }
      });
      item.addEventListener('mouseleave', function () {
        item.classList.remove('is-open');
      });
    });

    if (!root.dataset.cbMegaOutside) {
      root.dataset.cbMegaOutside = '1';
      document.addEventListener('click', function (e) {
        var inside = false;
        triggers.forEach(function (t) {
          if (t.contains(e.target)) inside = true;
        });
        if (!inside) closeAll(null);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAll(null);
      });
    }
  }

  function initHeaderHeight(root) {
    var nav = root.querySelector('.site-nav');
    if (!nav) return;
    var group = document.getElementById('header-group');
    function update() {
      document.body.style.setProperty('--header-height', nav.offsetHeight + 'px');
      document.body.style.setProperty('--header-group-height', (group ? group.offsetHeight : nav.offsetHeight) + 'px');
    }
    update();
    if (!nav.dataset.cbResize) {
      nav.dataset.cbResize = '1';
      window.addEventListener('resize', update, { passive: true });
    }
  }

  function init(root) {
    root = root || document;
    initModeToggle(root);
    initScroll(root);
    initMobileDrawer(root);
    initMega(root);
    initHeaderHeight(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Re-bind when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
